/* eslint-disable no-param-reassign */
import * as types from './types';
import api from '~/services/api';
import { handleErrors } from '../common';
import { decrementLoadingCounter, incrementLoadingCounter } from '../dispatch/actions';

const setElements = elements => ({
  type: types.SET_NREF_ELEMENTS,
  elements,
});

const setSubElements = subElements => ({
  type: types.SET_NREF_SUBELEMENTS,
  subElements,
});

const setCodes = codes => ({
  type: types.SET_NREF_CODES,
  codes,
});

const setCodeGroups = codeGroups => ({
  type: types.SET_NREF_CODE_GROUPS,
  codeGroups,
});

const setCodeTypes = codeTypes => ({
  type: types.SET_NREF_CODE_TYPES,
  codeTypes,
});

const setOperators = operators => ({
  type: types.SET_NREF_OPERATORS,
  operators,
});

const setOperatorsGroups = operatorsGroups => ({
  type: types.SET_NREF_OPERATORS_GROUPS,
  operatorsGroups,
});

const setEquipmentGroups = equipmentGroups => ({
  type: types.SET_NREF_EQUIPMENT_GROUPS,
  equipmentGroups,
});

const setEquipmentTypes = equipmentTypes => ({
  type: types.SET_NREF_EQUIPMENT_TYPES,
  equipmentTypes,
});

const setEquipments = equipments => ({
  type: types.SET_NREF_EQUIPMENTS,
  equipments,
});


const setMaterials = materials => ({
  type: types.SET_NREF_MATERIALS,
  materials,
});

export const getElements = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  // if (getState().nref.elements.length > 0) return;
  api.get('/nref/elements')
    .then(res => dispatch(setElements(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};

export const getSubElements = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  // if (getState().nref.subElements.length > 0) return;
  api.get('/nref/subelements')
    .then(res => dispatch(setSubElements(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};

export const getCodes = () => async (dispatch, _getState) => {
  api.get('/nref/codes')
    .then(res => dispatch(setCodes(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)));
};

export const getCodeGroups = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  api.get('/nref/codegroups')
    .then(res => dispatch(setCodeGroups(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};

export const getCodeTypes = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  api.get('/nref/codetypes')
    .then(res => dispatch(setCodeTypes(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};

export const getNrefOperators = () => async (dispatch, _getState) => {
  api.get('/nref/operators')
    .then(res => dispatch(setOperators(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)));
};

export const getNrefOperatorsGroups = () => async (dispatch, _getState) => {
  api.get('/nref/operatorsgroups')
    .then(res => dispatch(setOperatorsGroups(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)));
};
export const getMaterials = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  api.get('/nref/materials')
    .then(res => dispatch(setMaterials(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};
export const getEquipmentGroups = () => async (dispatch, _getState) => {
  api.get('/nref/equipmentgroups')
    .then(res => dispatch(setEquipmentGroups(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)));
};

export const getEquipmentTypes = (
  { dispatchLoading = false } = {},
) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  api.get('/nref/equipmenttypes')
    .then(res => dispatch(
      setEquipmentTypes(res.data?.result || []),
    ))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};

export const getEquipments = ({ dispatchLoading = false } = {}) => async (dispatch, _getState) => {
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  api.get('/nref/equipments')
    .then(res => dispatch(setEquipments(res.data?.result || [])))
    .catch(err => dispatch(handleErrors(err.response)))
    .finally(() => {
      if (dispatchLoading) dispatch(decrementLoadingCounter());
    });
};
